import React, { ReactNode, useContext, useEffect } from "react";
import io, { Socket } from "socket.io-client";

interface Props {
  url: string;
  children: ReactNode;
}

export const SocketContext = React.createContext<Socket | undefined>(undefined);

export function SocketProvider({ children, url }: Props): JSX.Element {
  const socket = io(url);

  useEffect(() => {
    return () => {
        socket.disconnect();
    }
  }, [socket]);

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
}

export function useSocket() {
  const context = useContext(SocketContext);
  if (context === undefined) {
    throw new Error("useSocket must be used within a SocketContext");
  }
  return context;
}
